import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=1626feda&"
import script from "./TheHeader.vue?vue&type=script&lang=js&"
export * from "./TheHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileNavBarPageHeader: require('/usr/src/motec/components/MobileNavBarPageHeader.vue').default,SearchPane: require('/usr/src/motec/components/search/Pane.vue').default})
